import React from "react";
import { composeText, GUIDES } from "@/data/curriculumGeometry";
import { useCursiveFont } from "@/lib/cursiveFont";

// Renders the whole cursive alphabet — dev helper used for visual QA against
// the reference chart. Route: /_dev/cursive-alphabet
export default function CursiveAlphabetPreview() {
  const font = useCursiveFont();
  const rows = [
    "AaBbCcDdEeFfGg",
    "HhIiJjKkLlMmNn",
    "OoPpQqRrSsTtUu",
    "VvWwXxYyZz",
  ];
  return (
    <div className="min-h-screen bg-[#FDFBF6] p-8" data-testid="cursive-preview">
      <h1 className="mb-2 font-heading text-3xl font-extrabold text-[#1F2937]">Cursive Alphabet</h1>
      <p className="mb-6 font-body text-sm text-[#6B7280]">
        {font
          ? "Paths extracted from Cedarville Cursive TTF — same coordinate space as the tracing pen."
          : "Loading Cedarville Cursive… showing hand-coded fallback."}
      </p>
      <div className="space-y-6">
        {rows.map((r) => {
          const t = composeText(r);
          return (
            <div key={r} className="rounded-2xl border-2 border-[#E5DECF] bg-white p-4">
              <svg viewBox={t.viewBox} width="100%" style={{ maxHeight: 220 }}>
                {[t.guidelines.top, t.guidelines.mid, t.guidelines.base, t.guidelines.bottom].map((y, i) => (
                  <line key={i} x1="0" x2={t.width} y1={y} y2={y}
                    stroke={y === GUIDES.base ? "#B91C1C" : "#7DD3FC"} strokeWidth="0.4" />
                ))}
                {t.strokes.map((s, i) => (
                  <path key={i} d={s.d} fill="#111827" stroke="#111827" strokeWidth="0.4"
                    strokeLinecap="round" strokeLinejoin="round" />
                ))}
              </svg>
            </div>
          );
        })}
      </div>
    </div>
  );
}
